import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinner } from 'primeng/progressspinner';
import { LoaderService } from '../../../core/services/loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule, ProgressSpinner],
  template: `
    @if (isLoading()) {
      <div class="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/15 dark:bg-black/35 backdrop-blur-[1.5px] transition-all duration-300 select-none pointer-events-auto">
        <div class="animate-loader-card flex flex-col items-center gap-4 bg-white/90 dark:bg-slate-900/90 px-8 py-6 rounded-2xl shadow-xl border border-slate-200/50 dark:border-slate-800/60 backdrop-blur-md">
          <p-progressSpinner 
            styleClass="w-10 h-10" 
            strokeWidth="4" 
            fill="transparent" 
            animationDuration=".8s" />
          <span class="text-xs font-semibold tracking-wide text-slate-700 dark:text-slate-300">
            Loading...
          </span>
        </div>
      </div>
    }
  `,
  styles: [`
    @keyframes fadeInZoom {
      from {
        opacity: 0;
        transform: scale(0.96);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    }
    .animate-loader-card {
      animation: fadeInZoom 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    }
  `]
})
export class LoaderComponent {
  private readonly loaderService = inject(LoaderService);
  protected readonly isLoading = this.loaderService.loading;
}
